import React from 'react'
import {Wrapper, ButtonWrapper} from '../styles/QuestionCards.style'
import {AnswerObject} from './Home'

interface Props {
  question: string
  answers: string[]
  callback: (e: React.MouseEvent<HTMLButtonElement>) => void
  userAnswer: AnswerObject | undefined
  questionNumber: number
  totalQuestions: number
}

const QuestionCards: React.FC<Props> = ({
  question,
  answers,
  callback,
  userAnswer,
  questionNumber,
  totalQuestions
}) => (
    <Wrapper>
      <p className='number'>
        Question: {questionNumber} / {totalQuestions}
      </p>
      <p className='question' dangerouslySetInnerHTML={{ __html: question }}></p>
      <div>
        {answers.map((answer, i) => (
          <ButtonWrapper 
            correct={userAnswer?.correctAnswer === answer}
            userClicked={userAnswer?.answer === answer}
            key = {i}>
            <button disabled={userAnswer ? true : false} value={answer} onClick={callback}>
              <span dangerouslySetInnerHTML={{ __html: answer }} />
            </button>
          </ButtonWrapper>
        ))}
      </div>
    </Wrapper>
  )


export default QuestionCards
